export default (a, b) => {
  const unionSize = new Set([...a, ...b]).size
  return unionSize === a.length && unionSize === b.length
}
